module.exports = __webpack_public_path__ + "static/img/ys-01.9a636c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ys-01.jpg
// module id = t8UI
// module chunks = 1